"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FeatureSection = void 0;
var _react = _interopRequireWildcard(require("react"));
var _formatID = _interopRequireDefault(require("../../../utils/formatID"));
var _LunaLink = _interopRequireDefault(require("../../LunaLink/LunaLink"));
var _FocusedImage = _interopRequireDefault(require("../../FocusedImage/FocusedImage"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const FeatureSection = props => {
  const {
    featureProps
  } = props;
  const {
    mouse,
    content,
    Link,
    hoveredFeature,
    mouseOverFeature,
    mouseLeave
  } = featureProps;
  const featuredContentHeader = content.featuredLinksTitle || "Featured Content";
  const promoImageSizes = {
    desktop: {
      width: 250,
      height: 165,
      ratio: {
        width: 50,
        height: 33
      }
    },
    tablet: {
      width: 250,
      height: 165,
      ratio: {
        width: 50,
        height: 33
      }
    },
    mobile: {
      width: 250,
      height: 165,
      ratio: {
        width: 50,
        height: 33
      }
    }
  };
  return /*#__PURE__*/_react.default.createElement(_react.Fragment, {
    key: `feature-section-${content?.contentfulId}`
  }, content?.featuredPromoImage && /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-feature-section__image-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_FocusedImage.default, {
    focalPointImage: content?.featuredPromoImage,
    className: `ter-feature-section__promo-image`,
    alt: content?.featuredPromoImage?.alt,
    fullHeightWrapper: false,
    imageSizes: promoImageSizes
  })), content?.featuredLinks && /*#__PURE__*/_react.default.createElement("p", {
    // id={formatID(`mega-menu-feature-header-text`)}
    className: "ter-mega-menu__category-title"
  }, featuredContentHeader), content?.featuredPromoDescription && /*#__PURE__*/_react.default.createElement("p", {
    className: "ter-mega-menu__category-description"
  }, content?.featuredPromoDescription), content?.featuredLinks?.map((link, index) => {
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, {
      key: `feature-link-${link?.contentfulId} || feature-link-${index}`
    }, link?.url && /*#__PURE__*/_react.default.createElement("div", {
      onMouseOver: () => mouseOverFeature(link?.contentfulId),
      onMouseLeave: () => mouseOverFeature(null)
    }, /*#__PURE__*/_react.default.createElement(_LunaLink.default, {
      className: `ter-feature-section__link ${mouse ? "" : "tabFocus"}`,
      tabIndex: mouse ? "" : "0",
      to: link?.url,
      onClick: mouseLeave
      // id={formatID(`${link.text}-mega-menu-title-link`)}
      ,
      Link: Link,
      target: typeof link?.external === "boolean" ? link?.external ? "_blank" : "_self" : null
    }, /*#__PURE__*/_react.default.createElement("p", {
      // id={formatID(`${link?.text}-mega-menu-title-link-text`)}
      className: `ter-feature-section__link--underline ${hoveredFeature === link?.contentfulId ? "ter-feature-section__link--underline--is-open" : ""}`
    }, link?.text))));
  }));
};
exports.FeatureSection = FeatureSection;